import {
	BanksPage,
	BanksQuery,
	DEFAULT_PAGINATION_OPTIONS,
	IBankService,
	PaginationLink
} from './interfaces/bank.interface';
import { AxiosResponse } from 'axios';
import { FincredibleBankPagination } from '../types/bank-integration-vendor';
import { client } from '../api/client';

export class FincredibleBankService implements IBankService {
	async fetchBanks(query: BanksQuery): Promise<BanksPage> {
		const size = query.paginationSize || DEFAULT_PAGINATION_OPTIONS.paginationSize;
		const page = (query.paginationOffset || 0) / size;
		const response: AxiosResponse<FincredibleBankPagination> = await client.get('v2/bank/institutions', {
			params: {
				country: query.country,
				name: query.searchTerm || undefined,
				size,
				page
			}
		});
		return {
			pagination: {
				offset: query.paginationOffset || 0,
				count: response.data.banks.length,
				total: response.data.count,
				prev: null,
				next: this.getNextOffset(response.data, page, size)
			},
			banks: response.data.banks.map((bank) => {
				return {
					id: bank.id,
					country: bank.country,
					popularity: bank.popularity,
					name: bank.name,
					bics: [bank.bic],
					logo: bank.logo,
					bankCodes: []
				};
			})
		};
	}

	private getNextOffset(banks: FincredibleBankPagination, page: number, size: number): PaginationLink | undefined {
		const nextOffset = (page + 1) * size;
		if (banks.count <= nextOffset) {
			return undefined;
		}
		return {
			offset: nextOffset,
			size: size
		};
	}
}

export const fincredibleBankService = new FincredibleBankService();
